import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragIndicator = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#757575",
		d: "M8 6C7.4375 6 7 5.5625 7 5C7 4.46875 7.4375 4 8 4C8.53125 4 9 4.46875 9 5C9 5.5625 8.53125 6 8 6ZM8 11C7.4375 11 7 10.5625 7 10C7 9.46875 7.4375 9 8 9C8.53125 9 9 9.46875 9 10C9 10.5625 8.53125 11 8 11ZM9 15C9 15.5625 8.53125 16 8 16C7.4375 16 7 15.5625 7 15C7 14.4688 7.4375 14 8 14C8.53125 14 9 14.4688 9 15ZM12 6C11.4375 6 11 5.5625 11 5C11 4.46875 11.4375 4 12 4C12.5312 4 13 4.46875 13 5C13 5.5625 12.5312 6 12 6ZM13 10C13 10.5625 12.5312 11 12 11C11.4375 11 11 10.5625 11 10C11 9.46875 11.4375 9 12 9C12.5312 9 13 9.46875 13 10ZM12 16C11.4375 16 11 15.5625 11 15C11 14.4688 11.4375 14 12 14C12.5312 14 13 14.4688 13 15C13 15.5625 12.5312 16 12 16Z"
	})
});
const ForwardRef = forwardRef(SvgDragIndicator);
export default ForwardRef;
